import React from "react";
import PropTypes from "prop-types";
import { Button, Message } from "semantic-ui-react";

const FilterNotification = ({
  isFilteredByUrl,
  urlPatronId,
  urlPatronName,
  urlLoanId,
  onClearFilters,
}) => {
  if (!isFilteredByUrl) return null;

  const getFilterDescription = () => {
    if (urlPatronName) {
      return `patron: ${urlPatronName}`;
    }
    if (urlPatronId) {
      return `patron ID: ${urlPatronId}`;
    }
    return `loan ID: ${urlLoanId}`;
  };

  return (
    <Message info>
      <Message.Header>Filtered View</Message.Header>
      <p>
        Showing results for {getFilterDescription()}
        {urlLoanId && " (from scanned barcode)"}
      </p>
      <Button
        size="small"
        onClick={onClearFilters}
        content="Show All Patrons"
        icon="remove filter"
      />
    </Message>
  );
};

FilterNotification.propTypes = {
  isFilteredByUrl: PropTypes.bool.isRequired,
  urlPatronId: PropTypes.string,
  urlPatronName: PropTypes.string,
  urlLoanId: PropTypes.string,
  onClearFilters: PropTypes.func.isRequired,
};

FilterNotification.defaultProps = {
  urlPatronId: null,
  urlPatronName: null,
  urlLoanId: null,
};

export default FilterNotification;
